module.exports = __webpack_public_path__ + "static/media/pipe-age.1bf1816b.svg";